import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { RoleNames, RoutePaths } from '../shared/api/types/enums';
import { RoleGuard } from '../shared/guards/role.guard';

// Pricing
export const pricingRoutes: Routes = [
  {
    path: RoutePaths.PricingPricesheets,
    loadChildren: () =>
      import('src/app/pricing/pricing/pricesheets/price-sheet.module').then((mod) => mod.PriceSheetModule),
    data: { role: [RoleNames.pricing, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.PricingTaxes,
    loadChildren: () => import('src/app/pricing/taxes/taxes.module').then((mod) => mod.TaxesModule),
    data: { role: [RoleNames.pricing, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.PricingSurcharges,
    loadChildren: () => import('src/app/pricing/surcharges/surcharges.module').then((mod) => mod.SurchargesModule),
    data: { role: [RoleNames.pricing, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  }
];
